import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function MorningRoutinePage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.morningRoutine.heading')}
      buttons={[
        {
          text: t('pages.onboarding.morningRoutine.options.within-5-minutes'),
          value: 'within-5-minutes',
        },
        {
          text: t('pages.onboarding.morningRoutine.options.within-30-minutes'),
          value: 'within-30-minutes',
        },
        {
          text: t('pages.onboarding.morningRoutine.options.after-breakfast'),
          value: 'after-breakfast',
        },
        {
          text: t('pages.onboarding.morningRoutine.options.it-varies'),
          value: 'it-varies',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
